export default "é\nou\nonde\no que\ncomo\nquantos\nquanto\ndeve\npode"